<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-3 form-title">
              <p><b>Saiba mais sobre a Dish</b></p>
              <span>Preencha o formulário e iremos entrar em contacto consigo.</span>
            </div>
            <fieldset>
                <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            id="input-fullName"
                            placeholder=" "
                            v-model="fullName"
                        >
                        <label>
                            Nome
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            id="input-phone"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'999999999'"
                        >
                        <label>
                            Contacto telefónico
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            id="input-email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="businessName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-businessName" :class="classes">
                        <input type="text"
                            id="input-businessName"
                            placeholder=" "
                            v-model="businessName"
                        >
                        <label>
                            Nome do Negócio
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="businessType" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-businessType" :class="classes">
                        <input type="text"
                            id="input-businessType"
                            placeholder=" "
                            v-model="businessType"
                        >
                        <label>
                            Tipo de Negócio
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="companyVAT" rules="required|nif" v-slot="{ classes }">
                  <div class="input-group input-group-companyVAT" :class="classes">
                    <input type="tel"
                           id="input-companyVAT"
                           placeholder=" "
                           v-model="companyVAT"
                           v-mask="'999999999'"
                    >
                    <label>
                      NIF Empresa
                    </label>
                  </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="tool" rules="required|alpha_spaces" v-slot="{ classes }">
                  <div class="input-group input-group-tool" :class="classes">
                    <select
                           id="input-tool"
                           placeholder=" "
                           v-model="tool"
                    >
                      <option value="" selected disabled>Que ferramenta tem interesse?</option>
                      <option value="DISH Professional Reservation">DISH Professional Reservation</option>
                      <option value="DISH Pay Now">DISH Pay Now</option>
                      <option value="Ambos">Ambos</option>
                    </select>
                  </div>
                </validation-provider>
                <span class="tw-mt-4 tw-mb-1 tw-block tw-text-white">Seleccione horario de contacto:</span>

                    <validation-provider class="tw-grid tw-grid-cols-3 tw-gap-3 hours-radio tw-mb-4" name="contactHours" rules="required" v-slot="{ classes }">
                        <label :class="{...classes, 'checked' : contactHours === '9h - 11h'}">
                            <input type="radio" value="9h - 11h" v-model="contactHours">
                            9h - 11h
                        </label>
                        <label :class="{...classes, 'checked' : contactHours === '11h - 15h'}">
                            <input type="radio" value="11h - 15h" v-model="contactHours">
                            11h - 15h
                        </label>
                            <label :class="{...classes, 'checked' : contactHours === '15h - 19h'}">
                            <input type="radio" value="15h - 19h" v-model="contactHours">
                            15h - 19h
                        </label>
                    </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label terms" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span>Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta"
                        id="submit"
                        :disabled="formLoading"
                    >
                        ENVIAR
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            businessName: '',
            businessType: '',
            contactHours: '',
            companyVAT: '',
            tool: '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                businessName: this.businessName,
                businessType: this.businessType,
                contactHours: this.contactHours,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'Email duplicado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/partials/variables";

form {
    padding: 18px 16px;
    background-color: $makro-blue;

    @screen lg {
        padding: 30px 35px;
        max-width: 400px;
        border-radius: 0 0 30px 30px;
    }

    .form-title {
        p {
            color: $makro-yellow;

            @screen lg {
                font-size: 24px;
            }
        }

        span {
            color: #fff;

            @screen lg {
                font-size: 14px;
            }
        }
    }

    .hours-radio {
        label {
            position: relative;
            display: block;
            padding: 17px 0;
            border-radius: 9px;
            background-color: #fff;
            color: $makro-blue;
            text-align: center;
            font-weight: 500;
            font-size: 15px;
            cursor: pointer;
            transition: all 0.15s ease-in-out;

            &.has-error {
                box-shadow: 0 0 3px 1px $red inset !important;
                color: $red;
            }

            &.checked {
                @apply tw-relative;
                //box-shadow: 0 0 3px 1px $makro-blue inset !important;
                font-weight: 700;

                &::before {
                  @apply tw-absolute tw-rounded-full tw-pointer-events-none tw-p-1;
                  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.516' height='10.059' viewBox='0 0 13.516 10.059'%3E%3Cg id='Group_2045' data-name='Group 2045' transform='translate(0.25 -48.75)'%3E%3Cpath id='Path_11054' data-name='Path 11054' d='M12.825,68.188a.651.651,0,0,0-.92,0l-7.8,7.8-3-3a.651.651,0,0,0-.92.92l3.457,3.457a.651.651,0,0,0,.92,0l8.257-8.257A.651.651,0,0,0,12.825,68.188Z' transform='translate(0 -18.997)' fill='%23fff' stroke='%23fff' stroke-width='0.5'/%3E%3C/g%3E%3C/svg%3E%0A");
                  background-color: #FFC85E;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 30px;
                  height: 30px;
                  bottom: -14px;
                }
            }

            input {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }
        }
    }
}

.terms {
    span {
        font-weight: 400;
        font-size: 10px;
    }
}
</style>
